import { fullName, downloadBlob, DAY_LABELS } from "./utils";

const CV_PREFIX = "upv_cv_";

export function saveCv(participantId, dataUrl) {
  try {
    localStorage.setItem(CV_PREFIX + participantId, dataUrl);
    return true;
  } catch (e) {
    return false;
  }
}

export function clearStoredCvs() {
  Object.keys(localStorage).filter((k) => k.startsWith(CV_PREFIX)).forEach((k) => localStorage.removeItem(k));
}

function dataUrlToBlob(url) {
  const [head, b64] = url.split(",");
  const mime = head.match(/:(.*?);/)?.[1] || "application/pdf";
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

export const hasUploadedCv = (p) => !!localStorage.getItem(CV_PREFIX + p.id);

export function getCvBlob(p) {
  const stored = localStorage.getItem(CV_PREFIX + p.id);
  return stored ? dataUrlToBlob(stored) : buildMockCvPdf(p);
}

export const downloadCv = (p) => downloadBlob(getCvBlob(p), p.cvFileName || "CV.pdf");

const SKILLS = {
  "Ingeniería Informática": ["Desarrollo full-stack (React, Node.js, Python)", "Cloud y DevOps (AWS, Docker, CI/CD)", "Bases de datos SQL y NoSQL"],
  "Ciencia de Datos": ["Python, pandas y scikit-learn", "Machine Learning y visualización de datos", "SQL y pipelines de datos"],
  "Ingeniería Industrial": ["Lean Manufacturing y mejora continua", "Diseño mecánico (SolidWorks, CATIA)", "Gestión de proyectos industriales"],
  "Ingeniería Eléctrica": ["Sistemas de potencia y energías renovables", "Automatización y PLC", "MATLAB / Simulink"],
  "Ingeniería Química": ["Simulación de procesos (Aspen)", "Control de calidad y seguridad industrial", "Sostenibilidad y economía circular"],
  Telecomunicaciones: ["Redes y comunicaciones 5G", "Sistemas embebidos e IoT", "Procesado de señal"],
  "Administración y Dirección de Empresas": ["Análisis financiero y control de gestión", "Marketing digital y estrategia", "Excel avanzado y Power BI"],
  "Ingeniería Civil": ["Cálculo de estructuras (SAP2000)", "BIM (Revit, Civil 3D)", "Planificación y gestión de obra"],
};

const pdfEsc = (s) => s.normalize("NFC").replace(/[^\x20-\xFF]/g, "-").replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");

export function buildMockCvPdf(p) {
  const ops = [];
  const text = (x, y, size, str, bold = false, color = "0.06 0.09 0.16") =>
    ops.push(`BT ${color} rg /${bold ? "F2" : "F1"} ${size} Tf ${x} ${y} Td (${pdfEsc(str)}) Tj ET`);
  ops.push("0.545 0 0 rg 0 818 595 24 re f");
  text(50, 768, 26, fullName(p).toUpperCase(), true);
  text(50, 746, 12, `${p.titulacion} \u00B7 ${p.centro} \u00B7 ${p.curso}`, false, "0.545 0 0");
  text(50, 727, 10, `${p.email}    ${p.phone}    ${p.linkedin || ""}`, false, "0.28 0.33 0.41");
  ops.push("0.89 0.91 0.94 RG 1 w 50 712 m 545 712 l S");
  let y = 686;
  const section = (title, lines) => {
    text(50, y, 11, title, true, "0.545 0 0");
    y -= 20;
    lines.forEach((l) => { text(50, y, 10.5, l); y -= 16; });
    y -= 14;
  };
  section("PERFIL", [
    `Estudiante de ${p.titulacion} en la Universitat Politecnica de Valencia.`,
    "Orientado/a a la resolucion de problemas, el trabajo en equipo y el aprendizaje continuo.",
    "Busco practicas o primer empleo en un entorno tecnologico e internacional.",
  ]);
  section("FORMACION", [`${p.titulacion} - ${p.centro}, Universitat Politecnica de Valencia (2023 - 2027)`, `Curso actual: ${p.curso}`]);
  section("EXPERIENCIA", ["Practicas en empresa - Departamento tecnico (6 meses)", "Proyecto final: desarrollo de una solucion aplicada con impacto real."]);
  section("COMPETENCIAS", SKILLS[p.titulacion] || ["Trabajo en equipo", "Comunicacion", "Analisis"]);
  section("IDIOMAS", ["Espanol y valenciano (nativo) \u00B7 Ingles (B2/C1)"]);
  text(50, 40, 8, `Curriculum de demostracion \u00B7 Foro de Empleo UPV 2027 (${DAY_LABELS[1]} - ${DAY_LABELS[2]}) \u00B7 Technology by Do IT Happen`, false, "0.5 0.55 0.6");

  const content = ops.join("\n");
  const objs = [
    "<< /Type /Catalog /Pages 2 0 R >>",
    "<< /Type /Pages /Kids [3 0 R] /Count 1 >>",
    "<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Resources << /Font << /F1 4 0 R /F2 5 0 R >> >> /Contents 6 0 R >>",
    "<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>",
    "<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>",
    `<< /Length ${content.length} >>\nstream\n${content}\nendstream`,
  ];
  let out = "%PDF-1.4\n";
  const offsets = [];
  objs.forEach((o, i) => { offsets.push(out.length); out += `${i + 1} 0 obj\n${o}\nendobj\n`; });
  const xref = out.length;
  out += `xref\n0 ${objs.length + 1}\n0000000000 65535 f \n` + offsets.map((o) => `${String(o).padStart(10, "0")} 00000 n \n`).join("");
  out += `trailer\n<< /Size ${objs.length + 1} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
  const bytes = new Uint8Array(out.length);
  for (let i = 0; i < out.length; i++) bytes[i] = out.charCodeAt(i) & 0xff;
  return new Blob([bytes], { type: "application/pdf" });
}

export function exportCandidatesCsv(rows, company) {
  const head = ["Nombre", "Apellidos", "Email", "Teléfono", "LinkedIn", "Titulación", "Centro", "Curso", "Fecha", "Hora", "Dispositivo", "Método", "CV"];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = rows.map(({ participant: p, interaction: i }) =>
    [p.firstName, p.lastName, p.email, p.phone, p.linkedin, p.titulacion, p.centro, p.curso, `${DAY_LABELS[i.day]} 2027`, i.time, i.deviceId, "Código QR", p.cvFileName].map(esc).join(";"));
  const csv = "\uFEFF" + [head.map(esc).join(";"), ...lines].join("\r\n");
  downloadBlob(new Blob([csv], { type: "text/csv;charset=utf-8" }), `candidatos_${company.toLowerCase()}_foro_upv_2027.csv`);
}
